// ** React Imports
/* eslint-disable  */
import { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { useSkin } from "@hooks/useSkin";

// ** Icons Imports
import { Disc, X, Circle } from "react-feather";
import { hasManyPermission } from "@utils";

// ** Utils
import { getUserData } from "@utils";
import LineLogo from "@src/assets/images/logo/linelogo.png";
import LineLogoDark from "@src/assets/images/logo/logoline-white.png";
const VerticalMenuHeader = (props) => {
  // ** Props
  const {
    menuCollapsed,
    setMenuCollapsed,
    setMenuVisibility,
    setGroupOpen,
    menuHover,
  } = props;
  const { skin } = useSkin();

  const illustration = skin === "dark" ? "logoline-white.png" : "linelogo.png",
    source = require(`@src/assets/images/logo/${illustration}`).default;

  // ** Vars
  const user = getUserData();
  const containerRef = useRef(null);

  // ** Reset open group
  useEffect(() => {
    if (!menuHover && menuCollapsed) setGroupOpen([]);
  }, [menuHover, menuCollapsed]);

  // ** Menu toggler component
  const Toggler = () => {
    if (!menuCollapsed) {
      return (
        <Disc
          size={20}
          data-tour="toggle-icon"
          className="text-primary toggle-icon d-none d-xl-block"
          onClick={() => setMenuCollapsed(true)}
        />
      );
    } else {
      return (
        <Circle
          size={20}
          data-tour="toggle-icon"
          className="text-primary toggle-icon d-none d-xl-block"
          onClick={() => setMenuCollapsed(false)}
        />
      );
    }
  };

  return (
    <div className="navbar-header" ref={containerRef}>
      <ul className="nav navbar-nav flex-row">
        <li className="nav-item me-auto">
          {hasManyPermission(["owner"]) ? (
            <NavLink to={"/dashboard/ecommerce"} className="">
              <span className="brand-logo">
                <img src={source} />
              </span>
              {/* <h2 className='brand-text mb-0'>{themeConfig.app.appName}</h2> */}
            </NavLink>
          ) : (
            <span className="brand-logo">
              <img src={source} />
            </span>
          )}
        </li>
        <li className="nav-item nav-toggle">
          <div className="nav-link modern-nav-toggle cursor-pointer">
            <Toggler />
            <X
              onClick={() => setMenuVisibility(false)}
              className="toggle-icon icon-x d-block d-xl-none"
              size={20}
            />
          </div>
        </li>
      </ul>
    </div>
  );
};

export default VerticalMenuHeader;
